'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = wixInstalledAppsSaga;

var _effects = require('redux-saga/effects');

var _WixInstance = require('@wix/wixrest-utils/dist/WixInstance');

var _WixInstance2 = _interopRequireDefault(_WixInstance);

var _WixInstalledAppsActions = require('../actions/WixInstalledAppsActions');

var WixInstalledAppsActions = _interopRequireWildcard(_WixInstalledAppsActions);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(handleGetInstalledApps),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(waitForGetInstalledApps),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(wixInstalledAppsSaga);

// Wrapper for the Wix.SuperApps.getInstalledInstance to make it a promise
function getInstanceFromWixAppId(getInstalledInstance, appName, appId) {

    var deferred = _q2.default.defer();

    try {
        getInstalledInstance(appId, function (ret) {
            deferred.resolve({ type: appName, appId: appId, value: ret });
        }, function (err) {
            deferred.reject(err);
        });
    } catch (e) {
        deferred.reject(e);
    }

    return deferred.promise;
}

// Wrapper for the all the getInstanceFromWixAppId including a timeout
function getAllAppsInstances(getInstalledInstance, apps) {
    var promises = _lodash2.default.map(apps, function (app) {
        return getInstanceFromWixAppId(getInstalledInstance, app.name, app.id).timeout(5000, 'Timeout');
    });
    return _q2.default.allSettled(promises);
}

function handleGetInstalledApps(sagaParams) {
    var wixInstance, getInstalledInstance, possibleApps, results, apps, failed;
    return _regenerator2.default.wrap(function handleGetInstalledApps$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    if (sagaParams.Wix) {
                        _context.next = 2;
                        break;
                    }

                    throw '[WixInstalledAppsSaga] No Wix namespace!';

                case 2:
                    if (sagaParams.Wix.SuperApps) {
                        _context.next = 4;
                        break;
                    }

                    throw '[WixInstalledAppsSaga] No Wix.SuperApps namespace!';

                case 4:
                    _context.next = 6;
                    return (0, _effects.select)(function (state) {
                        return state.wixInstance;
                    });

                case 6:
                    wixInstance = _context.sent;
                    getInstalledInstance = Wix.SuperApps.getInstalledInstance || (Wix.SuperApps.Settings || {}).getInstalledInstance;

                    if (getInstalledInstance) {
                        _context.next = 10;
                        break;
                    }

                    throw '[WixInstalledAppsSaga] No getInstalledInstance function!';

                case 10:
                    possibleApps = [{ name: 'menus', id: _WixInstance2.default.MENUS_APP_ID }, { name: 'orders', id: _WixInstance2.default.ORDERS_APP_ID }, { name: 'reservations', id: _WixInstance2.default.SEATING_APP_ID }];
                    _context.next = 13;
                    return (0, _effects.call)(function () {
                        return getAllAppsInstances(getInstalledInstance, possibleApps);
                    });

                case 13:
                    results = _context.sent;
                    apps = {};

                    _lodash2.default.each(results, function (result) {
                        if (result.state === 'fulfilled') {
                            apps[result.value.appId] = result.value.value.instanceId;
                        };
                    });

                    failed = _lodash2.default.isEmpty(apps) && wixInstance.parsed;

                    if (failed) {
                        apps[wixInstance.appId] = wixInstance.parsed.instanceId;
                    }

                    _context.next = 20;
                    return (0, _effects.put)(WixInstalledAppsActions.actions.getInstalledAppsSuccess({ apps: apps, success: !failed }));

                case 20:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
};

function waitForGetInstalledApps(sagaParams) {
    return _regenerator2.default.wrap(function waitForGetInstalledApps$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeEvery)(WixInstalledAppsActions.types.GET_INSTALLED_APPS, handleGetInstalledApps.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

function wixInstalledAppsSaga(sagaParams) {
    return _regenerator2.default.wrap(function wixInstalledAppsSaga$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return (0, _effects.all)([(0, _effects.fork)(waitForGetInstalledApps.bind(null, sagaParams))]);

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}